'use client';

import { useAssistantToolUI } from '@assistant-ui/react';
import { toolUIRegistry } from './tool-ui';

/**
 * Tool UI Provider
 * Registers all Tool UIs with assistant-ui using hooks
 * Each hook call must be at the top level (not in loops)
 *
 * CRITICAL: Key names MUST match agent's tools object keys (camelCase)
 * NOT the tool's id (kebab-case). Mastra streams use the object key.
 */
export function ToolUIProvider({ children }: { children: React.ReactNode }) {
  // Phase 2: Core Tools
  useAssistantToolUI(toolUIRegistry['createMemo'].unstable_tool);
  useAssistantToolUI(toolUIRegistry['updateMemo'].unstable_tool);
  useAssistantToolUI(toolUIRegistry['instantPreview'].unstable_tool);
  useAssistantToolUI(toolUIRegistry['exportMoment'].unstable_tool);
  useAssistantToolUI(toolUIRegistry['exportMemo'].unstable_tool);

  // Phase 3: Collections & Compound Video
  useAssistantToolUI(toolUIRegistry['createCollection'].unstable_tool);
  useAssistantToolUI(toolUIRegistry['addMomentToCollection'].unstable_tool);
  useAssistantToolUI(toolUIRegistry['listCollections'].unstable_tool);
  useAssistantToolUI(toolUIRegistry['compoundVideo'].unstable_tool);
  useAssistantToolUI(toolUIRegistry['previewMomentEdits'].unstable_tool);

  // Transcript export
  useAssistantToolUI(toolUIRegistry['exportTranscript'].unstable_tool);

  // Phase 4: Workflows
  useAssistantToolUI(toolUIRegistry['createContentWorkflow'].unstable_tool);
  useAssistantToolUI(toolUIRegistry['discoverContentWorkflow'].unstable_tool);

  // Phase 5: Social Post Previews
  useAssistantToolUI(toolUIRegistry['generateSpeakerPost'].unstable_tool);
  useAssistantToolUI(toolUIRegistry['createPostFromMoment'].unstable_tool);

  // Phase 6: Search Results
  useAssistantToolUI(toolUIRegistry['searchMoments'].unstable_tool);

  return <>{children}</>;
}
